
import React from 'react';
import { LogIn } from 'lucide-react';

export const GoogleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <LogIn strokeWidth={1.5} {...props} />
);
